import { AxiosResponse, AxiosError } from "axios";

import { ALLOWANCE_API_ENDPOINTS } from "@/features/allowance/api/endpointsAllowance";
import { legacyAllowanceModelToNewModel } from "@/features/allowance/helpers/formatLegacyAllowanceModels";
import { AllowanceLegacyModel } from "@/features/allowance/types/allowanceLegacyModel";
import { AllowanceBaseModel } from "@/features/allowance/types/allowanceModels";
import apiRequests from "@/shared/config/axiosConfig";

export default async function getAllowances(
  wbsEntryId: string
): Promise<AllowanceBaseModel[]> {
  try {
    const url = ALLOWANCE_API_ENDPOINTS.GET_ALLOWANCES.replace(
      "{wbsEntryId}",
      wbsEntryId
    );
    const response: AxiosResponse<AllowanceLegacyModel[]> = await apiRequests.get(url);

    if (response.status === 200) {
      const allowanceLegacyModel: AllowanceLegacyModel[] = response.data;
      const allowances: AllowanceBaseModel[] =
        legacyAllowanceModelToNewModel(allowanceLegacyModel);

      return allowances;
    }

    throw new Error(`Unknown error occurred with status code ${response.status}`);
  } catch (e) {
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
